import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServicesComponent from '../components/Services';

const Services = () => {
    return (
        <>
            <Helmet>
                <title>Our Services - Community Plus Care Services</title>
                <meta name="description" content="Explore our wide range of NDIS services including SIL, Community Participation, and Personal Care." />
            </Helmet>
            <ServicesComponent />
        </>
    );
};

export default Services;
